import { useEffect, useCallback } from 'react';
import { useDashboardStore } from '../store/useDashboardStore';
import { PiUserCircle, PiUsers, PiCurrencyDollar, PiTrendUp } from 'react-icons/pi';

export const useDashboard = () => {
  const {
    itemsCustomers,
    itemsPostpago,
    itemsPrepago,
    totalPostpago,
    totalPrepago,
    totalAmount,
    momStats,
    records,
    renovation,
    cronLogs,
    loadingBanks,
    rollbackData,
    openRollBack,
    fetchDashboardData,
    toggleRollback,
    closeRollback,
    rollBackRenovation,
    sendingEmail,
    sendEmailReport
  } = useDashboardStore();

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  const customerStats = [
    { 
      title: "Total usuarios", 
      value: itemsCustomers, 
      diff: momStats?.customers?.diff || 0,
      icon: <PiUsers size="20" />, 
      color: "yellow", 
      mono: true 
    },
    { 
      title: "Usuarios Postpago", 
      value: itemsPostpago, 
      diff: momStats?.postpago?.diff || 0,
      icon: <PiUserCircle size="20" />, 
      color: "gray", 
      mono: true 
    },
    { 
      title: "Usuarios Prepago", 
      value: itemsPrepago, 
      diff: momStats?.prepago?.diff || 0,
      icon: <PiUserCircle size="20" />, 
      color: "gray", 
      mono: true 
    }
  ];

  const financialStats = [
    { 
      title: "Total Ingresos", 
      value: totalAmount, 
      diff: momStats?.revenue?.diff || 0,
      icon: <PiTrendUp size="20" />, 
      color: "yellow", 
      currency: true 
    },
    { 
      title: "Recaudación Postpago", 
      value: totalPostpago, 
      diff: 0, // We could add this if we aggregate revenue by type in MoM
      icon: <PiCurrencyDollar size="20" />, 
      color: "gray", 
      currency: true 
    },
    { 
      title: "Recaudación Prepago", 
      value: totalPrepago, 
      diff: 0, 
      icon: <PiCurrencyDollar size="20" />, 
      color: "gray", 
      currency: true 
    }
  ];

  return {
    customerStats,
    financialStats,
    records,
    renovation,
    cronLogs,
    loadingBanks,
    rollbackData,
    openRollBack,
    sendingEmail,
    toggleRollback,
    closeRollback,
    rollBackRenovation,
    sendEmailReport,
    refresh: fetchDashboardData
  };
};
